import validator from 'validator';
import { isInteger, isNumber, isCuit, isSube, isCBU, isCVU, isDNI, isLC, isLE, isCI } from './validators';

validator.isInteger = isInteger;
validator.isNumber = isNumber;
validator.isCuit = isCuit;
validator.isSube = isSube;
validator.isCBU = isCBU;
validator.isCVU = isCVU;
validator.isDNI = isDNI;
validator.isLC = isLC;
validator.isLE = isLE;
validator.isCI = isCI;

export default validator;
